export class EvaButtonGhost{
    name:string;
    type:string;
    size:string;
    icon: any;
    constructor(name:string,
                type:string,
                size:string){
        this.name=name;
        this.type=type;
        this.size=size;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/eva-button-ghost/eva-button-ghost.ts